import { useToast } from '@chakra-ui/react';
import React, { useEffect } from 'react';

import { lokalisation } from '../../helpers/lokalisation';

const WORKED_SOLUTION_ERROR_TOAST_ID = 'worked-solution-error-toast';

type WorkedSolutionErrorFallbackProps = {
    onToastShown?: () => void
};

export const WorkedSolutionErrorFallback: React.FC<WorkedSolutionErrorFallbackProps> = ({ onToastShown }) => {
    const toast = useToast();
    const {
        errorTxt: { errorMessage },
        qtcRendererTxt: { corruptedData }
    } = lokalisation();

    useEffect(() => {
        if (!toast.isActive(WORKED_SOLUTION_ERROR_TOAST_ID)) {
            toast({
                id: WORKED_SOLUTION_ERROR_TOAST_ID,
                title: errorMessage,
                description: corruptedData,
                status: 'error',
                duration: 3000
            });
        }

        onToastShown?.();
    }, [toast, errorMessage, corruptedData, onToastShown]);

    return <></>;
};
